import { ListChecks, Target, Trophy, AlertTriangle } from "lucide-react";
import { useStore } from "@/store/AppStore";
import { PageHeader, KpiCard } from "@/components/kit";
import { ChecklistCard } from "@/components/Lists";
import { TaskBoard } from "@/components/TaskBoard";
import { JourneyCard } from "@/components/Attendance";
import { BirthdayPanel } from "@/components/Birthdays";
import { CollabMaintenance } from "@/components/Maintenance";
import { MonthHighlights } from "@/components/Highlights";
import { myMaintenance } from "@/lib/maintenance";

const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Bom dia" : h < 18 ? "Boa tarde" : "Boa noite";
};
import { visibleTasks, taskStats } from "@/lib/tasks";
import { ranking } from "@/lib/selectors";
import { PROFILES } from "@/data/mock";
import { fmtDate } from "@/lib/format";
import { TODAY } from "@/data/mock";

export default function CollabToday() {
  const { state, toggleChecklistItem, setProof } = useStore();
  const { collaboratorId, companyId, name } = PROFILES.colaboradora;
  const tasks = visibleTasks(state, state.collaborators.find((c) => c.id === collaboratorId));
  const st = taskStats(tasks);
  const checklists = state.checklists.filter((c) => c.collaboratorId === collaboratorId);
  const me = ranking(state, companyId).find((r) => r.id === collaboratorId);

  return (
    <div data-testid="collab-today-page">
      <PageHeader eyebrow={`Hoje · ${fmtDate(TODAY)}`} title={`${greeting()}, ${name.split(" ")[0]}`} subtitle="Sua rotina organizada para um dia incrível." />
      <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4">
        <KpiCard testId="collab-kpi-tasks" icon={ListChecks} label="Tarefas" value={`${st.done}/${st.total}`} hint={st.overdue ? `${st.overdue} atrasada(s) · ${st.pct}%` : `${st.pct}% concluídas`} />
        <KpiCard testId="collab-kpi-goal" icon={Target} label="Minha meta" value={`${me.att}%`} hint="Vendas do mês" />
        <KpiCard testId="collab-kpi-ranking" icon={Trophy} label="Ranking" value={`${me.position}º`} hint={`${me.score} pontos`} />
        <KpiCard testId="collab-kpi-overdue" icon={AlertTriangle} label="Atrasadas" value={st.overdue} hint={`${st.awaiting} aguardando aprovação`} />
      </div>
      <div className="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-5">
        <div className="xl:col-span-5"><JourneyCard collab={state.collaborators.find((c) => c.id === collaboratorId)} /></div>
        <div className="xl:col-span-5"><MonthHighlights companyId={companyId} certificates={false} /></div>
        <div className="xl:col-span-5"><BirthdayPanel companyIds={[companyId]} title="Aniversariantes" /></div>
        <div className="xl:col-span-5"><CollabMaintenance collab={me} items={myMaintenance(state, me)} /></div>
        <div className="xl:col-span-2" data-testid="collab-tasks-panel">
          <TaskBoard tasks={tasks} mode="collab" companyId={companyId} actor={name} title="Minhas tarefas" />
        </div>
        <div className="xl:col-span-3">
          <h2 className="mb-1 font-display text-lg font-semibold">Checklists</h2>
          <p className="mb-4 text-xs text-neutral-500">Use "Prova" para anexar a foto de cada atividade operacional. Itens administrativos são marcados direto.</p>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="collab-checklists">
            {checklists.map((cl) => <ChecklistCard key={cl.id} checklist={cl} onToggle={toggleChecklistItem} onProof={setProof} />)}
          </div>
        </div>
      </div>
    </div>
  );
}
